import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { fDateTime } from 'utils/formatTime';


export default function OrderTimelineView({events}) {
  return (
    <Timeline
      sx={{
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: 0.2,
        },
      }}
    >
      {events.map((item) => <TimelineItem key={item.id}>
            <TimelineOppositeContent color="textSecondary">
              {fDateTime(item.created_at)}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Typography variant="h6" component="span">
                {item.title}
              </Typography>
              <Typography>{item.message}</Typography>
            </TimelineContent>
          </TimelineItem>)}
      
    </Timeline>
  );
}


OrderTimelineView.propTypes = {
  events: PropTypes.array,
}